<script lang="ts">
    import { onMount, afterUpdate } from 'svelte';
    import IconRadioButtonChecked from './Icons/IconRadioButtonChecked.svelte';
    import IconRadioButtonUnchecked from './Icons/IconRadioButtonUnchecked.svelte';

    export let label: string = '';
    export let checked: boolean = false;
    export let disabled: boolean = false;
    export let onSet: () => void = () => {};
    export let scale: number = 1;

</script>

<div class="container" class:disabled={disabled}>
    <div class="radio-button">
        {#if checked}
            <IconRadioButtonChecked
                scale={scale}
            />
        {:else}
            <IconRadioButtonUnchecked
                on:click={function() {
                    checked = true;
                    onSet();
                }}
                scale={scale}
            />
        {/if}
    </div>
    <div class="label" on:click={function() {
        checked = true;
        onSet();
    }}>
        {label}
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }
    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    .label:hover {
        cursor: pointer;
    }
</style>
